import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Flex } from 'grid-styled';

import { Header } from '../styledSystem/Text';
import Button from '../uic/Button';
import './Modal.css';

import StreamDestinationModal from './StreamDestinationModal';
import StreamNameModal from './StreamNameModal';
import StreamInputModal from './StreamInputModal';
import StreamEncoderModal from './StreamEncoderModal';

class StreamModal extends Component {
    componentDidMount() {
        this.validateModel();
    }

    validateModel = () => {
        const { model } = this.props;

        let validationVariable = model.validateAllModel();
        let validationObject = {};

        if (validationVariable.length > 0) {
            for (let i = 0; i < validationVariable.length; i++) {
                validationObject[validationVariable[i]] = model.validate(
                    validationVariable[i]
                );
            }

            this.props.updateState({
                formErrors: validationObject,
                formValid: false
            });
        } else {
            this.props.updateState({
                formErrors: validationObject,
                formValid: true
            });
        }
    };

    render() {
        const {
            model,
            updateState,
            statevariable,
            formValid,
            onSave,
            onClose
        } = this.props;

        return (
            <React.Fragment>
                <Header>Stream Name</Header>
                <StreamNameModal
                    model={model}
                    validateModel={this.validateModel}
                    updateState={updateState}
                    statevariable={statevariable}
                />
                <Header>Stream Input</Header>
                <StreamInputModal
                    model={model}
                    validateModel={this.validateModel}
                    updateState={updateState}
                    statevariable={statevariable}
                />
                <Header>Stream Encoder</Header>
                <StreamEncoderModal
                    model={model}
                    validateModel={this.validateModel}
                    updateState={updateState}
                    statevariable={statevariable}
                />
                <Header>Stream Destinations</Header>
                <StreamDestinationModal
                    model={model}
                    validateModel={this.validateModel}
                    updateState={updateState}
                    statevariable={statevariable}
                />
                <Flex justifyContent="flex-end" mt={10}>
                    <Button icon="close" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button icon="check" onClick={onSave} disabled={!formValid}>
                        Save
                    </Button>
                </Flex>
            </React.Fragment>
        );
    }
}

export default inject('model')(observer(StreamModal));



// WEBPACK FOOTER //
// ./src/form/StreamModal.js